import { Persona } from "@fluentui/react-components";
const Person = (props) => {
    return (
     
        
    
        <Persona
        size="small"
        textAlignment="center"
        name={props.details && props.details.displayName ? props.details.displayName : "Kevin Sturgis"}
        
          avatar={
        props.avatar?.image?.src
          ? {
              image: {
                src: props.avatar.image.src, 
              },
            }
          : {
              color: "colorful", 
            }
      }
        />)
}
export default Person;